import React from "react";
import { Menu, Sidebar } from "semantic-ui-react";

const SidebarMenu = ({ items, pathname, Link, visible, numberOfCartItem }) => {
  numberOfCartItem = numberOfCartItem===0 ? " " :  `(${numberOfCartItem})`
  const isActive = item => {
    if (!pathname) return true;
    return (item.exact) ? pathname === item.path : pathname.startsWith(item.path);
  }
  const activeItem = items.find(item => isActive(item)) || {};
  return (
    <Sidebar as={Menu} animation="slide along" width="thin"
      className="mobile only"
      visible={visible} icon="labeled" vertical inverted={activeItem.inverted}>
      {items.map((item) => {
        const active = isActive(item);
        return (
          <Menu.Item as={Link} to={item.path} active={active} key={item.path}>
            {item.name}
          </Menu.Item>
        );
      })}
      <Menu.Item as={Link} to="/cart/" active={ pathname ? pathname.startsWith("/cart") : false} >
        Cart&nbsp;{numberOfCartItem}
      </Menu.Item>

    </Sidebar>
  );
};

// const mapStateToProps = (state: StoreState) => ({
//   visible: state.isSidebarVisible,
// });

// export default connect<any, void, SidebarMenuProps>(mapStateToProps)(SidebarMenu);

export default SidebarMenu;
